import { cn } from "@/lib/utils";
import { forwardRef } from "react";

type Props = React.ComponentProps<"section">;

const Container = forwardRef<HTMLElement | null, Props>(
  ({ className, children, ...props }, ref) => (
    <section
      ref={ref}
      className={cn(`px-5 md:px-14 lg:px-20`, className)}
      {...props}
    >
      {children}
    </section>
  )
);

Container.displayName = "Container";

export default Container;
